import React from "react";
import * as S from "./styles";
export var Account = function Account(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/xlink",
    viewBox: "0 1 24 24",
    "aria-hidden": "true",
    height: 24,
    width: 24
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 2)"
  }, React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "11",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, React.createElement("circle", {
    id: "a",
    cx: "11",
    cy: "11",
    r: "10.5"
  })), React.createElement("circle", {
    cx: "11",
    cy: "7.5",
    r: "3.5",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    mask: "url(#b)"
  }), React.createElement("circle", {
    cx: "11",
    cy: "21.5",
    r: "7.5",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    mask: "url(#b)"
  })));
};